import { Pendencia } from "../../components/pendencia/Pendencia";

export const PendenciaPage = () => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <Pendencia />
        </div>
    );
}